import type { ProviderAccountListItem } from '@cotera/api';

export const formatProviderAccountStatusLabel = (
  account: Pick<ProviderAccountListItem, 'status' | 'isBuiltIn'>
): string => {
  if (account.isBuiltIn === true) {
    return 'Built-in';
  }

  switch (account.status) {
    case 'default':
      return 'Default';
    case 'active':
      return 'Active';
    case 'disabled':
      return 'Disabled';
    case 'archived':
      return 'Archived';
  }
};

export const providerAccountStatusTone = (
  account: Pick<ProviderAccountListItem, 'status' | 'isBuiltIn'>
): 'built-in' | 'active' | 'default' | 'muted' => {
  if (account.isBuiltIn === true) {
    return 'built-in';
  }

  if (account.status === 'default') {
    return 'default';
  }

  if (account.status === 'active') {
    return 'active';
  }

  return 'muted';
};
